import { SUPPLIER_SUBACCOUNT as LABELS } from './labels.js';
import { DIALOG_TABLE_MAX_HEIGHT } from '../../../../lib/const';
import { generateDictURLWithLang, getApiPath } from '../../../../lib/utils';

const baseUrl = getApiPath();

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    highlightCurrentRow: true,
    selection: false,
    searchShow: false,
    searchBtn: true,
    addBtn: false,
    columnBtn: false,
    refreshBtn: false,
    menu: false,
    index: true,
    indexLabel: LABELS.serialNumber,
    border: true,
    labelPosition: 'top',
    searchSpan: 12,
    searchMenuSpan: 12,
    maxHeight: DIALOG_TABLE_MAX_HEIGHT,
    emptyText: LABELS.noData,
    column: [
      {
        slot: true,
        label: LABELS.checked,
        width: 50,
        prop: 'checked'
      },
      {
        label: LABELS.supplierAccount,
        prop: 'toElsAccount',
        searchSpan: 12,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.supplierName,
        prop: 'supplierName',
        searchSpan: 12,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.subAccount,
        prop: 'elsSubAccount',
        searchSpan: 12,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.personName,
        prop: 'name',
        searchSpan: 12,
        searchLabelWidth: 140,
        search: true
      },
      {
        label: LABELS.state,
        prop: 'firstType',
        type: 'select',
        dicUrl: generateDictURLWithLang(
          `${baseUrl}/ElsSearchDictionaryService/no-auth/dict/supplierType`,
          true
        )
      }
    ]
  }
};
